<template>
  <div>
    <span class="num" @click="showEdit = true" v-if="!showEdit">
      {{ value }}
      <i class="icon-edit fa-solid fa-pen-to-square"></i>
    </span>
    <div class="wrapper" v-if="showEdit">
      <input class="input" type="text" placeholder="Digite seu texto" @keyup.enter.prevent="done" v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)" v-if="showEdit" />
      <span @click="done" v-if="showEdit">
        <i class="fa-solid fa-check"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputTextEdit",
  props: ["params", "enter", "value"],
  data() {
    return {
      showEdit: false,
    };
  },
  methods: {
    done() {
      this.showEdit = false;
      if (this.enter) this.enter(this.params);
    }
  },

};
</script>

<style scoped>
.input {
  width: 90%;
  border: none;
  text-align: center;
}

.wrapper {
  height: 37px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #eaedf3;
  box-shadow: 0px 10px 20px -6px rgb(0 0 0 / 3%);
}

.wrapper span {
  width: 10px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
}

.icon-edit {
  margin-left: 0px;
  color: rgb(128, 127, 127);
  cursor: pointer;
}
</style>
